import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { DataEntitiesControllerService, DataEntity } from '@osos/shared/api';
import {
  DataEntityPresenterModel,
  IndexableLocalizedItem,
  LocalizedValueModel,
  Where,
} from '@osos/shared/types';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiUtilsService } from '../../api-utils/api-utils.service';

@Injectable()
export class EntityDataService extends DataEntitiesControllerService {
  constructor(private apiHelper: ApiUtilsService) {
    super();
  }

  public getEntitiesWithIdenticalNames(
    name: LocalizedValueModel,
    id?: string,
    moduleId?: string,
  ): Observable<IndexableLocalizedItem[]> {
    const localizedNameFilter: Where<DataEntityPresenterModel> =
      this.apiHelper.prepareLocalPropFilter({
        name,
        id,
      });
    const filter: Where<DataEntityPresenterModel> = {
      ...localizedNameFilter,
      module: moduleId,
    };
    return this.find(
      this.apiHelper.prepareFilter({
        where: filter,
        fields: { id: true, name: true },
      }),
    ).pipe(map((entities) => entities as Array<IndexableLocalizedItem>));
  }

  public countEntitiesWithNormalizedNameOf(
    value: string,
    id?: string,
  ): Observable<number> {
    const idCond = id ? { id: { neq: id } } : {};
    return this.count(
      this.apiHelper.prepareWhere<DataEntity>({
        normalizedName: value,
        ...idCond,
      }),
    ).pipe(map((count) => count?.count || 0));
  }

  //TODO move the part that is related to validation to another place, and only return the part
  //That is related to the response only
  public checkModuleEntitiesCount(
    moduleId: string,
  ): Observable<ValidationErrors> {
    return this.count(
      this.apiHelper.prepareWhere<DataEntity>({
        module: moduleId,
      }),
    ).pipe(
      switchMap((count) => {
        return count?.count == 0 ? of({ hasNoEntities: true }) : of(null);
      }),
    );
  }
}
